import { App } from "@capacitor/app";
import { useEffect } from "react";
import { bs, useBoundStore } from "state/bound.store";
import { useConnectivityStore } from "../connectivity/connectivity.store";

/**
 * Replays queued favourite changes on mount, on sign-in, when a connection returns and when
 * the app comes to the foreground. Renders nothing and shows nothing while it runs.
 */
export const FavouriteSyncManager = () => {
  useEffect(() => {
    const flush = async () => {
      if (!useConnectivityStore.getState().isConnectivityAvailable) return;
      if (!bs().loginCompleted) return;

      // Queued changes go up before the server's list comes down, so a list that predates
      // an offline change cannot overwrite it.
      await bs().syncFavourites();
      await bs().loadFavourites();
    };

    void flush();

    const unsubscribeConnectivity = useConnectivityStore.subscribe(
      (state) => state.isConnectivityAvailable,
      (available) => {
        if (available) void flush();
      },
    );

    // This mounts above the auth screens, so the first flush usually runs with no user yet.
    const unsubscribeLogin = useBoundStore.subscribe(
      (state) => state.loginCompleted,
      (completed) => {
        if (completed) void flush();
      },
    );

    const listener = App.addListener("appStateChange", (state) => {
      if (state.isActive) void flush();
    });

    return () => {
      unsubscribeConnectivity();
      unsubscribeLogin();
      void listener.then((handle) => handle.remove());
    };
  }, []);

  return null;
};
